export const LOG_IN = "[USER] LOG IN";
export const LOG_OUT = "[USER] LOG OUT";
